export default {
  // 新手引导
  finishButton: "完成",

  // 输入框和搜索
  addressPlaceholder: "请输入地址或者调证用户ID",
  queryButton: "查询",

  // 标签管理
  labelManagement: "标签管理",
  addLabel: "添加标签",

  // 空状态
  emptyMessage: "请输入地址或调证用户ID以查询对应标签",
  loading: "拼命加载中",

  // 标签信息
  recentOperator: "最近操作人",
  modifyButton: "修改",
  balance: "余额",

  // 删除确认
  deleteConfirmTitle: "删除确认",
  deleteConfirmMessage: "是否要删除此条标签？",
  no: "否",
  yes: "是",
  deleteSuccess: "删除成功",
  deleteCanceled: "已取消删除",

  // 标签对话框
  addLabelTitle: "添加标签",
  modifyLabelTitle: "修改标签",
  labelSelect: "标签",
  pleaseSelect: "请选择",
  pleaseInput: "请输入内容",
  cancel: "取 消",
  confirm: "确 定",
  addNew: "新增",

  // 验证消息
  requiredFieldError: "*号为必填项",
  pleaseEnterAddress: "请输入地址或者调证用户ID",

  // 审核相关
  reviewTitle: "标签审核提示",
  reviewMessage:
    "当前添加的地址标签包含关键属性，需等待管理员审核通过后方可生效。",
  submitSuccessWithReview:
    "提交成功，管理员审核通过后方可在{productName}中查看",
  addLabelSuccess: "此数据已成功打上该标签",
  modifyLabelSuccess: "修改标签成功",

  // 删除操作
  deleteConfirm: "确认删除当前标签？",

  // 复制功能
  copySuccess: "复制成功",

  // 表单验证提示
  pleaseSelectOption: "请选择",
  pleaseInputField: "请输入{field}",

  // tagdetialfn.js 相关字符串
  // 删除确认
  deleteConfirmMessage: "此操作将永久删除该标签, 是否继续?",
  deleteConfirmTitle: "删除确认",

  // 按钮文本
  confirm: "确定",
  cancel: "取消",

  // 成功消息
  addLabelSuccess: "此节点已成功打上该标签",
  deleteLabelSuccess: "删除标签成功",
  deleteCanceled: "已取消删除",

  // 平台地址
  platformAddress: "平台地址",
};
